import React, { FC, RefObject, useCallback, useRef, useState } from 'react';
import './SubscriptionPeriodSelector.scss';
import { Button, ButtonSize, ButtonTheme } from './Button';
import { Popup, PopupTheme } from '../components/Popup/Popup';
import { SubscriptionPeriodType } from '../../../models/Article';
import { useTranslation } from 'react-i18next';
import { UseMutationResult } from '@tanstack/react-query';
import { ErrorResponse } from '../notification/actions';

export type SubscriptionPeriodSelectorProps = {
    bulkChangeSubscriptionPeriodMutation: UseMutationResult<void, ErrorResponse, SubscriptionPeriodType>;
    isNothingSelected: boolean;
};

export const SubscriptionPeriodSelector: FC<SubscriptionPeriodSelectorProps> = ({
    bulkChangeSubscriptionPeriodMutation: { isLoading, mutate },
    isNothingSelected
}) => {
    const toggleRef = useRef<HTMLElement>(null);
    const [expanded, setExpanded] = useState(false);
    const { t } = useTranslation();

    const handleClose = useCallback(() => {
        setExpanded(false);
    }, []);
    return (
        <>
            <div className="subscription-start-selector">
                <Button
                    ref={toggleRef as RefObject<HTMLButtonElement>}
                    size={ButtonSize.SMALL}
                    theme={ButtonTheme.NEUTRAL}
                    text={t('shop.subscriptions.changeSubscriptionStart')}
                    title={t('shop.subscriptions.changeSubscriptionStart')}
                    onClick={() => setExpanded(it => !it)}
                    isLoading={isLoading}
                    disabled={isLoading || isNothingSelected}
                    icon="start"
                />
                <Popup
                    target={toggleRef}
                    visible={expanded}
                    placement="bottom-start"
                    gap={0}
                    arrow={false}
                    onClose={handleClose}
                    portal={false}
                    theme={PopupTheme.LIGHT}
                >
                    <button
                        className="gild"
                        key={SubscriptionPeriodType.CURRENT}
                        onClick={() => {
                            mutate(SubscriptionPeriodType.CURRENT);
                            setExpanded(!expanded);
                        }}
                    >
                        <i className="icon start"></i>
                        {t('components.subscriptionPeriodPopup.immediately')}
                    </button>
                    <button
                        className="gild"
                        key={SubscriptionPeriodType.NEXT}
                        onClick={() => {
                            mutate(SubscriptionPeriodType.NEXT);
                            setExpanded(!expanded);
                        }}
                    >
                        <i className="icon start"></i>
                        {t('components.subscriptionPeriodPopup.nextSubscriptionYear')}
                    </button>
                </Popup>
            </div>
        </>
    );
};
